import { useState } from 'react';
import { Input } from '../../../components/Form/Input';

const requirements = [
  { label: 'At least 8 characters', test: (pw: string) => pw.length >= 8 },
  { label: 'One uppercase letter', test: (pw: string) => /[A-Z]/.test(pw) },
  { label: 'One lowercase letter', test: (pw: string) => /[a-z]/.test(pw) },
  { label: 'One number', test: (pw: string) => /\d/.test(pw) },
  {
    label: 'One special character',
    test: (pw: string) => /[^A-Za-z0-9]/.test(pw),
  },
];

export function PasswordInput() {
  const [password, setPassword] = useState('');

  // const failed = requirements.filter((r) => !r.test(password));

  return (
    <div className="space-y-2 w-full">
      <Input
        name="password"
        label="Password"
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="w-full"
      />
      <ul
        className={`text-sm space-y-1 transition-all duration-400 ease-in-out ${
          password ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {requirements.map((r) => {
          const passed = r.test(password);
          return (
            <li
              key={r.label}
              className={passed ? 'text-green-600' : 'text-red-600'}
            >
              {passed ? '✓' : '✗'} {r.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
